module.exports = __webpack_public_path__ + "img/confirm-btn_yes.f08ef286.png";